$(function(){
  initpromogridslide();
  destroySlideshow();
  initpromobannerslide();
  onloaddestroySlideshow();

  // setTimeout(function(){
  //   initgridslider();
  //   initgridrecentlyslider();
  // }, 2000);

  if (location.href.includes('/products')) {
  onloadGetProductImgArray();
  }

});


//start of display variant img
//global variable img swap function

var $imgContainer = $('.jsc-product-slideshow');
var $childArrayElement = $imgContainer.find('.jsc-carousell');

onloadGetProductImgArray = () =>{
  var $isShow = false;
  var $childArray = $imgContainer.children();
  var $flickityConfig = $imgContainer.attr('data-flickity-config');
  var $obj = JSON.parse($flickityConfig);
  var $selectedColor = $('.jsc-ColorSwatch:checked').val();
  var $currentselectedColor = $('.jsc-ColorSwatch:checked').val() + '-';
  var $producttitle = $('.jsc-pdp-title').attr('data-title');
  var $thumdot = $(".jsc-deskThumbnail");
  console.log($selectedColor);
  console.log($currentselectedColor);

  //show selected thumbnails dots ipad 1000px
    $thumdot.each(function(){
      var $datathumbdot = $(this).attr('data-alt');
      if ( $datathumbdot.includes($selectedColor) || $datathumbdot == $currentselectedColor || $datathumbdot == "main_image" || $datathumbdot == $producttitle) {
        $(this).show();
      }
      else {
        $(this).hide();
      }
    });


  destroyProductSlider();

  // remove all product image
  $imgContainer.children().remove();

  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElement.length; i++) {
    var $thisAltText = $($childArrayElement[i]).attr('data-img-alt');
    if ($thisAltText.includes($selectedColor) || $thisAltText == $currentselectedColor || $thisAltText == "main_image" || $thisAltText == $producttitle) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }
  }

  initProductSlider($isShow,$obj);

}

variantImageSwap = (evt,color,currentcolor) =>{
  var $this = $(evt);
  var $isShow = false;
  var $flickityConfig = $imgContainer.attr('data-flickity-config');
  var $obj = JSON.parse($flickityConfig);
  var $producttitle = $('.jsc-pdp-title').attr('data-title');
  var $thumdot = $(".jsc-deskThumbnail");

  //show selected thumbnails dots ipad 1000px
  $thumdot.each(function(){
      var $datathumbdot = $(this).attr('data-alt');
      if ($datathumbdot.includes(color) || $datathumbdot == currentcolor || $datathumbdot == "main_image" || $datathumbdot == $producttitle) {
        $(this).show();
      }
      else {
        $(this).hide();
      }
    });

  // Destroy slider
  destroyProductSlider();


  // remove all slider image
  $imgContainer.children().remove();


  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElement.length; i++) {
    var $thisAltText = $($childArrayElement[i]).attr('data-img-alt');
    if ( $thisAltText.includes(color) || $thisAltText == currentcolor || $thisAltText == "main_image" || $thisAltText == $producttitle) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
      console.log($thisAltText);
      console.log(color);
    }
  }

  initProductSlider($isShow,$obj);
}


initProductSlider = (isShow,obj) =>{
  if (isShow) {
    var flkty = new Flickity( '.jsc-product-slideshow', obj);
  }
}

destroyProductSlider = () =>{
  var flkty = new Flickity( '.jsc-product-slideshow', {
  // options
  cellAlign: 'left',
  contain: true
  });
  flkty.destroy();
  console.log('hello');
}

destroySlideshow = () =>{
    if ($(window).width() <= 799) {

      var galleryElems = document.querySelectorAll('.jsc-hero');
      for ( var i=0, len = galleryElems.length; i < len; i++ ) {
        var galleryElem = galleryElems[i];

        var flkty = new Flickity( galleryElem, {
        // options
        cellAlign: 'left',
        contain: true
        });
        flkty.destroy();
        var flkty = new Flickity( galleryElem, {
        // options
        autoPlay: false,
        pageDots: true,
        prevNextButtons: false,
        adaptiveHeight: true,
        setGallerySize: true,
        fade: true,
        imagesLoaded: true,
        contain: true
      });

      }

        $('.jsc-hero').addClass('jsc-newflickity');
    }else {
        console.log('remove new flickity');
        var galleryElems = document.querySelectorAll('.jsc-hero');
        for ( var i=0, len = galleryElems.length; i < len; i++ ) {
          var galleryElem = galleryElems[i];

          var flkty = new Flickity( galleryElem, {
          // options
          cellAlign: 'left',
          contain: true
          });
          flkty.destroy();
          var flkty = new Flickity( galleryElem, {
          // options
          autoPlay: false,
          pageDots: true,
          prevNextButtons: false,
          adaptiveHeight: true,
          setGallerySize: true,
          fade: true,
          imagesLoaded: true,
          contain: true
        });
        }

        $( window ).resize(function() {
          for ( var i=0, len = galleryElems.length; i < len; i++ ) {
            var galleryElem = galleryElems[i];

            var flkty = new Flickity( galleryElem, {
            // options
            cellAlign: 'left',
            contain: true
            });
            flkty.destroy();
            var flkty = new Flickity( galleryElem, {
            // options
            autoPlay: false,
            pageDots: true,
            prevNextButtons: false,
            adaptiveHeight: true,
            setGallerySize: true,
            fade: true,
            imagesLoaded: true,
            contain: true
          });
          }

        });

    }
}

onloaddestroySlideshow = () =>{
  if ($(window).width() <= 799) {
    var galleryElems = document.querySelectorAll('.jsc-hero');
    for ( var i=0, len = galleryElems.length; i < len; i++ ) {
      var galleryElem = galleryElems[i];

      var flkty = new Flickity( galleryElem, {
      // options
      cellAlign: 'left',
      contain: true
      });
      flkty.destroy();
      var flkty = new Flickity( galleryElem, {
      // options
      autoPlay: false,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      setGallerySize: true,
      fade: true,
      imagesLoaded: true,
      contain: true
    });

    }

      $('.jsc-hero').addClass('jsc-newflickity');
  }
}

initpromogridslide = () =>{
  var $promogrid = $('.jsc-flex-grid');

  if ($promogrid.length > 0 ) {

    var galleryElems = document.querySelectorAll('.jsc-flex-grid');
    for ( var i=0, len = galleryElems.length; i < len; i++ ) {
      var galleryElem = galleryElems[i];

      if ($(window).width() > 480 && $(window).width() <= 799) {

        var flkty = new Flickity( galleryElem, {
        // options
        cellAlign: 'center',
        contain: false,
        pageDots: true,
        groupCells: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        wrapAround:true
      });

      }else {

      var flkty = new Flickity( galleryElem, {
      // options
      cellAlign: 'left',
      contain: false,
      pageDots: true,
      groupCells: false,
      adaptiveHeight: true,
      prevNextButtons: true,
      wrapAround:true
    });

    }

    }

    if ($(window).width() > 799) {
    $( window ).resize(function() {
      for ( var i=0, len = galleryElems.length; i < len; i++ ) {
        var galleryElem = galleryElems[i];

        var flkty = new Flickity( galleryElem, {
        // options
        cellAlign: 'left',
        contain: false,
        pageDots: true,
        groupCells: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        wrapAround:true
      });

      flkty.destroy();

      if ($(window).width() > 480 && $(window).width() <= 799) {

        var flkty = new Flickity( galleryElem, {
        // options
        cellAlign: 'center',
        contain: false,
        pageDots: true,
        groupCells: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        wrapAround:true
      });

      }else {

        var flkty = new Flickity( galleryElem, {
        // options
        cellAlign: 'left',
        contain: false,
        pageDots: true,
        groupCells: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        wrapAround:true
      });

      }

      }

    });
  }


  }
}

initpromobannerslide = () =>{
  var $promogrid = $('.jsc-banner-grid');

  if ($promogrid.length > 0 ) {

    var galleryElems = document.querySelectorAll('.jsc-banner-grid');
    for ( var i=0, len = galleryElems.length; i < len; i++ ) {
      var galleryElem = galleryElems[i];

      var flkty = new Flickity( galleryElem, {
      // options
      pageDots: true,
      prevNextButtons: true,
      freeScroll: true,
      adaptiveHeight: true,
      wrapAround:true
    });

    }
    if ($(window).width() > 799) {
    $( window ).resize(function() {
      for ( var i=0, len = galleryElems.length; i < len; i++ ) {
        var galleryElem = galleryElems[i];

        var flkty = new Flickity( galleryElem, {
        // options
        pageDots: true,
        prevNextButtons: true,
        freeScroll: true,
        adaptiveHeight: true,
        wrapAround:true
      });

      flkty.destroy();

        var flkty = new Flickity( galleryElem, {
        // options
        pageDots: true,
        prevNextButtons: true,
        freeScroll: true,
        adaptiveHeight: true,
        wrapAround:true
      });

      }

    });
  }

  }
}

initgridslider = () =>{
  var $promogrid = $('.jsc-grid-flickity');
  $promogrid.show();
  $('.jsc-loading').hide();

  if ($promogrid.length > 0 ) {

    var galleryElems = document.querySelectorAll('.jsc-grid-flickity');
    for ( var i=0, len = galleryElems.length; i < len; i++ ) {
      var galleryElem = galleryElems[i];

      var flkty = new Flickity( galleryElem, {
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: true,/*ddn-false*/
      groupCells: false,
      adaptiveHeight: false,
      prevNextButtons: true,
      freeScroll: true
    });

    }
    if ($(window).width() > 799) {
    $( window ).resize(function() {
      for ( var i=0, len = galleryElems.length; i < len; i++ ) {
        var galleryElem = galleryElems[i];

        var flkty = new Flickity( galleryElem, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,/*ddn-false*/
        groupCells: false,
        adaptiveHeight: false,
        prevNextButtons: true,
        freeScroll: true
      });

      flkty.destroy();

          var flkty = new Flickity( galleryElem, {
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: true,/*ddn-false*/
          groupCells: false,
          adaptiveHeight: false,
          prevNextButtons: true,
          freeScroll: true
        });

      }

    });
  }

  }
}

initgridrecentlyslider = () =>{
  var $promogrid = $('.jsc-recently .grid.grid--uniform.aos-init.aos-animate');
  $('.jsc-recently').show();
  $('.jsc-loading').hide();

  if ($promogrid.length > 0 ) {

    var galleryElems = document.querySelectorAll('.jsc-recently .grid.grid--uniform.aos-init.aos-animate');
    for ( var i=0, len = galleryElems.length; i < len; i++ ) {
      var galleryElem = galleryElems[i];

      var flkty = new Flickity( galleryElem, {
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      groupCells: false,
      adaptiveHeight: false,
      prevNextButtons: true,
      freeScroll: true
    });

    }
    if ($(window).width() > 799) {
    $( window ).resize(function() {
      for ( var i=0, len = galleryElems.length; i < len; i++ ) {
        var galleryElem = galleryElems[i];

        var flkty = new Flickity( galleryElem, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        groupCells: false,
        adaptiveHeight: false,
        prevNextButtons: true,
        freeScroll: true
      });

      flkty.destroy();

          var flkty = new Flickity( galleryElem, {
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          groupCells: false,
          adaptiveHeight: false,
          prevNextButtons: true,
          freeScroll: true
        });

      }

    });
  }

  }
}



onclickTab = (evt) =>{
  var $tabheaderData = $(evt).attr('data-tab');
  var $tabheaderClass = $('.jsc-tabs');
  var $tabcontentClass = $('.jsc-tabs-content');

  $tabheaderClass.each(function(){

    var $dataTabs = $(this).attr('data-tab');

    if ($dataTabs == $tabheaderData) {
      $(this).addClass('jsc-tabs-active');
    }else {
      $(this).removeClass('jsc-tabs-active');
    }

  });

  $tabcontentClass.each(function(){

    var $dataTabscontent = $(this).attr('data-tab');

    if ($dataTabscontent == $tabheaderData) {
      $(this).show();
    }else {
      $(this).hide();
    }

  });

}

dropdown = (evt) =>{
  var dropdownContent = $(evt).next();
  dropdownContent.toggleClass("content-open");
  $(evt).toggleClass("button-active");

}

footerRegion = (evt) =>{
  var open = $(evt).data("isopen");
  if(open) {
      window.location.href= $(evt).val();
  }
  $(evt).data("isopen", !open);
}

validateCheckout = () =>{
  if ($("#CartPageAgree").length > 0) {

    if($("#CartPageAgree").prop('checked') == true){
      console.log('checked');
      $("#jsc-real-checkout").click();
    }else {
      console.log('not checked');
      alert('You must agree with the terms and conditions of sales to check out.');
    }

  }else {
    $("#jsc-real-checkout").click();
  }
}

$('div.page-width div.h5 a:contains("SALE")').closest('.h5').addClass('sale-megamenu');
$('li.mobile-nav__item div.mobile-nav__child-item a:contains("SALE")').closest('.mobile-nav__child-item').addClass('sale-megamenu');

$('div.page-width div.h5 a:contains("Special Offers")').closest('.h5').addClass('orange-megamenu');
$('li.mobile-nav__item div.mobile-nav__child-item a:contains("Special Offers")').closest('.mobile-nav__child-item').addClass('orange-megamenu');

$('div.page-width ul.site-nav a:contains("Promo")').closest('.li').addClass('orange-megamenu');
$('li.mobile-nav__item div.mobile-nav__child-item a:contains("Promo")').closest('.mobile-nav__child-item').addClass('orange-megamenu');

$('div.page-width div.h5 a:contains("Tide Chart")').closest('.h5').addClass('orange-megamenu');
$('li.mobile-nav__item div.mobile-nav__child-item a:contains("Tide Chart")').closest('.mobile-nav__child-item').addClass('orange-megamenu');